export const ENUM_LABELS: Record<string, string> = {
  NONE: '不跳转', ARTICLE: '文章详情', PRODUCT: '商品详情', CONSULTATION: '专家咨询', EXTERNAL: '外部链接',
  DRAFT: '草稿', PENDING_REVIEW: '待审核', PUBLISHED: '已发布', REJECTED: '已驳回', OFFLINE: '已下架', ONLINE: '已上架',
  ACTIVE: '正常', BANNED: '已禁用', INACTIVE: '未激活', NORMAL: '正常', ENABLED: '启用', DISABLED: '已停用',
  VISIBLE: '显示中', HIDDEN: '已隐藏', BOUND: '已绑定', UNBOUND: '已解绑', REVOKED: '已解绑', OPEN: '招募中', ENDED: '已结束',
  EARN: '获得', DEDUCT: '扣减', IN: '收入', OUT: '支出', REFUNDED: '已退款',
  BLOOD_SUGAR: '血糖', BLOOD_PRESSURE: '血压', WEIGHT: '体重', EXERCISE: '运动', DIET: '饮食', MEDICATION: '用药',
  PENDING: '待处理', PROCESSING: '处理中', SUCCESS: '成功', FAILED: '失败', CLOSED: '已关闭', CANCELLED: '已取消',
  PENDING_PAYMENT: '未支付', PAID: '待发货', SHIPPED: '已发货', COMPLETED: '已完成', FULL_REFUNDED: '已退款',
  REQUESTED: '已申请', REVIEWING: '审核中', APPROVED: '已通过', REPLIED: '已回复', RATED: '已评价',
  FROZEN: '冻结中', AVAILABLE: '可提现', SETTLED: '已结算', REVERSED: '已冲正', WITHDRAWN: '已提现',
  CONFIGURED: '已配置', NOT_CONFIGURED: '未配置', OK: '正常', WARNING: '需关注', ERROR: '异常',
  WECHAT: '微信支付', ORIGINAL: '原路退回', PAYMENT: '支付', REFUND: '退款', COMMISSION: '佣金', WITHDRAWAL: '提现',
  LOGISTICS: '物流服务', DIET_AI: '饮食 AI', LIVE: '小程序直播', DEVICE: '健康设备', OSS: '图片存储',
  ADMIN: '超级管理员', OPS: '运营', GOODS: '商品', ORDER: '订单', FIN: '财务', CONTENT: '内容', HEALTH: '健康', VOL: '志愿者', AUDIT: '审计',
  BREAKFAST: '早餐', LUNCH: '午餐', DINNER: '晚餐', SNACK: '加餐',
  // B-19 血糖 8 监测时段 + 老 mealType 三值兼容
  DAWN: '凌晨', BEFORE_BREAKFAST: '早餐前', AFTER_BREAKFAST: '早餐后',
  BEFORE_LUNCH: '午餐前', AFTER_LUNCH: '午餐后', BEFORE_DINNER: '晚餐前',
  AFTER_DINNER: '晚餐后', BEFORE_SLEEP: '睡前',
  BEFORE: '餐前', AFTER: '餐后', RANDOM: '随机',
  // B-19 糖尿病类型(HEALTH='健康' 上面已有,OTHER 其他场景含义不同,均不重复收录)
  TYPE1: 'Ⅰ型糖尿病', TYPE2: 'Ⅱ型糖尿病', GESTATIONAL: '妊娠糖尿病', SPECIAL: '特殊类型糖尿病',
  BLOOD_SUGAR_HIGH: '血糖偏高', BLOOD_SUGAR_LOW: '血糖偏低', MEAL_GAP_LARGE: '餐前餐后差值过大', BLOOD_PRESSURE_HIGH: '血压偏高', URIC_ACID_HIGH: '尿酸偏高',
  UNREAD: '未读', READ: '已读', HANDLED: '已处理', TIMEOUT: '超时',
  STEPS: '步数', HEART_RATE: '心率', URIC_ACID: '尿酸', BLOOD_KETONE: '血酮',
  UPCOMING: '未开始', ONGOING: '进行中', FINISHED: '已结束',
};

export const enumLabel = (value?: string | null) => value ? (ENUM_LABELS[value] || value) : '—';

export const statusTagType = (value?: string | null): 'success' | 'warning' | 'danger' | 'info' | 'primary' => {
  if (!value) return 'info';
  if (['ONLINE', 'PUBLISHED', 'ACTIVE', 'SUCCESS', 'COMPLETED', 'CONFIGURED', 'OK', 'AVAILABLE', 'APPROVED', 'PAID', 'ENABLED', 'HANDLED'].includes(value)) return 'success';
  if (['PENDING', 'PROCESSING', 'PENDING_REVIEW', 'PENDING_PAYMENT', 'REFUNDING', 'FROZEN', 'WARNING', 'REQUESTED', 'UNREAD'].includes(value)) return 'warning';
  if (['FAILED', 'REJECTED', 'BANNED', 'ERROR', 'TIMEOUT'].includes(value)) return 'danger';
  if (['DRAFT', 'OFFLINE', 'INACTIVE', 'DISABLED', 'CLOSED', 'CANCELLED', 'NOT_CONFIGURED', 'READ'].includes(value)) return 'info';
  return 'primary';
};

export const LINK_TYPE_OPTIONS = [
  { value: 'NONE', label: '不跳转' },
  { value: 'ARTICLE', label: '文章详情' },
  { value: 'PRODUCT', label: '商品详情' },
  { value: 'CONSULTATION', label: '专家咨询' },
  { value: 'EXTERNAL', label: '外部链接' },
];
